module.exports = __webpack_public_path__ + "static/media/bctLogo.0aea6981.png";